import React from 'react';
import {useNavigate} from 'react-router-dom';
import './App.css';

function TeamButton({
                        team,
                        label,
                        image,
                        onClick,
                    }: {
    team: 'edouard' | 'juliette';
    label: string;
    image?: string;
    onClick: () => void;
}) {
    return (
        <button
            className={`team-button team-button--${team}`}
            onClick={onClick}
            aria-label={`Choisir Team ${label}`}
        >
            <div className="team-button__image-slot">
                {image && <img src={image} alt={label} className="team-button__img"/>}
            </div>
            <span className="team-button__name">{label}</span>
        </button>
    );
}

export default function App() {
    const navigate = useNavigate();
    const handleTeamClick = (team: 'edouard' | 'juliette') => navigate('/accueil', {state: {team}});

    return (
        <div className="app">
            <div className="content">

                <div className="title-block">
                    <span className="title-la">Le</span>
                    <span className="title-pacs">PACS</span>
                    <p className="title-made-in">made in</p>
                    <span className="title-names">Édouard et Juliette</span>
                </div>

                <p className="invitation-text">
                    Nous sommes heureux de vous convier <br/>à la célébration de notre PACS <br/>le 6 juin 2026 !
                </p>

                <div className="divider"/>

                <div className="team-section">
                    <p className="team-prompt"><span className="bold-span">Choisis ta team</span><br/>(Le choix est
                        anonyme mais on vous rappelle qu'Édouard est ingénieur informatique)</p>
                    <div className="figures-row">
                        <TeamButton team="edouard" label="Édouard" image="/samuel.png" onClick={() => handleTeamClick('edouard')}/>
                        <TeamButton team="juliette" label="Juliette" image="/julie.png" onClick={() => handleTeamClick('juliette')}/>
                    </div>
                </div>

            </div>
        </div>
    );
}
